"use client";

import { useAuth } from "@/components/auth-provider";
import { createClient } from "@/utils/supabase/client";
import { useEffect, useRef } from "react";

export function AuthFocusChecker() {
  const { claims } = useAuth();
  const lastUserId = useRef<string | undefined | null>(claims?.sub);

  useEffect(() => {
    lastUserId.current = claims?.sub;
  }, [claims?.sub]);

  useEffect(() => {
    const supabase = createClient();

    const handleFocus = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const currentUserId = session?.user?.id ?? null;

      if (currentUserId !== lastUserId.current) {
        lastUserId.current = currentUserId;
      }
    };

    const abortController = new AbortController();

    window.addEventListener("focus", handleFocus, {
      signal: abortController.signal,
    });
    return () => {
      abortController.abort();
    };
  }, []);

  return null;
}
